













































import Vue from "vue";
import { login } from "../../services";
export default Vue.extend({
  name: "app-login",
  data: () => ({
    username: "",
    password: "",
    loginError: false,
  }),
  methods: {
    async submit() {
      this.loginError = false;
      const loggedIn = await login(this.username, this.password);
      if (loggedIn) {
        (this.$refs.form as any).reset();
        const urlParams = new URLSearchParams(window.location.search);
        let next = urlParams.get('next');
        if (!next) {
            next = '/'
        }
        window.location.href = next;
      } else {
        this.loginError = true;
      }
    },
  },
});
